import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=4281e861&"
import script from "./NewRegister.vue?vue&type=script&lang=ts&"
export * from "./NewRegister.vue?vue&type=script&lang=ts&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports